import React from 'react';
import { ReferenceArea } from 'recharts';

/**
 * AnimatedReferenceArea
 * @param {boolean} show 是否显示
 * @param {boolean} above 鼠标在lastPrice上方
 * @param {number} minY Y轴下界
 * @param {number} maxY Y轴上界
 * @param {number} lastPrice 分界线价格
 */

export default function AnimatedReferenceArea({ show, minY, maxY, onAreaClick }) {
  return (
    <g>
      {/* 统一点击区域 */}
      <ReferenceArea
        y1={minY}
        y2={maxY}
        fill="transparent"
        isFront={false}
        style={{
          pointerEvents: show ? 'auto' : 'none',
          cursor: show ? 'pointer' : 'default',
        }}
        onClick={() => show && onAreaClick && onAreaClick('unified')}
      />
    </g>
  );
}

